import React from 'react';
import PropTypes from 'prop-types';
import FolderItem from './FolderItem';

const FileRow = (props) => {
  const { item } = props;
  if (!('type' in item)) {
    return null;
  }
  return (
    <FolderItem {...props} canMutate={Boolean(item.relationships.mutateItem)} />
  );
};

FileRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export { FileRow };
